import {
  getCurrentPracticeId,
  getPracticeColorsById,
} from "../store/chainSlice";
import { useMainStore } from "../store/mainStore";
import {
  getBrandingDarkColor,
  getBrandingLightColor,
  getBrandingMediumColor,
} from "../utils/helpers";
import { colors } from "./colors";

export interface ExtendedTheme {
  dark: boolean;
  colors: {
    primary: string;
    light: string;
    medium: string;
    dark: string;
    background: string;
    black: string;
    white: string;
    success: string;
    lightRed: string;
  };
}

export const useStyles = () => {
  const practiceId = useMainStore(getCurrentPracticeId);

  const practiceColors = useMainStore((state) =>
    getPracticeColorsById(state, practiceId || ""),
  );

  const primaryColor = practiceColors?.primary || colors.primary;
  const mediumColor = colors?.primary
    ? getBrandingMediumColor(primaryColor)
    : colors.medium;
  const darkColor = colors?.primary
    ? getBrandingDarkColor(primaryColor)
    : colors.dark;
  const lightColor = colors?.primary
    ? getBrandingLightColor(primaryColor)
    : colors.light;
  const CustomLightTheme: ExtendedTheme = {
    dark: false,
    colors: {
      primary: primaryColor,
      light: lightColor,
      medium: mediumColor,
      dark: darkColor,
      background: colors.background,
      black: colors.black,
      white: colors.white,
      success: colors.success,
      lightRed: colors.lightRed,
    },
  };

  const CustomDarkTheme: ExtendedTheme = {
    ...CustomLightTheme,
    dark: true,
  };

  return CustomDarkTheme;
};
